const i18n = {
  'notifications': {
    'user': '使用者：',
    'message': '傳送給你一個好友邀請',
    'viewProfile': '查看個人檔案',
  }
};
export default i18n;
